<template>
  <footer class="footer-area bg-white text-center rounded-top-7" style="    line-height: 1rem;">
    <p style="    line-height: inherit;" class="text-muted small mb-0 pb-0" v-html="t('common.footer.disclaimer', 'Le informazioni e i calcoli forniti da questo strumento sono simulazioni a scopo puramente informativo e non costituiscono una consulenza fiscale o legale. Per una valutazione accurata della tua posizione, rivolgiti sempre a un professionista qualificato.')"></p>
    <p class="fs-14">
      <small>
        <span>Smart Rate® Copyright {{ currentYear }} All Rights Reserved | P.IVA 04195250362 | Made with ❤ by </span>
        <a href="https://cactus.farm" target="_blank" class="text-decoration-none text-muted">Cactus Farm srl</a>
      </small>
    </p>
  </footer>
</template>

<script setup lang="ts">
import { t } from '@/utils/i18nHelper';
import { computed } from 'vue';

const currentYear = computed(() => new Date().getFullYear());
</script>